import { z } from 'zod';

/** Error codes in the API envelope. See design doc §4.1. */
export const errorCodeSchema = z.enum([
  'VALIDATION',
  'UNAUTHORIZED',
  'FORBIDDEN',
  'NOT_FOUND',
  'CONFLICT',
  'RECIPIENT_NOT_OPTED_IN',
  'TEMPLATE_NOT_APPROVED',
  'TEMPLATE_PARAM_MISMATCH',
  'UNSUPPORTED_MEDIA_TYPE',
  'MEDIA_NOT_FOUND',
  'MEDIA_TOO_LARGE',
  'RATE_LIMITED',
  'ALLOWLIST_BLOCKED',
  'INVALID_STATE',
  'INTERNAL',
]);
export type ErrorCode = z.infer<typeof errorCodeSchema>;

export const errorEnvelopeSchema = z.object({
  error: z.object({
    code: errorCodeSchema,
    message: z.string(),
    details: z.record(z.unknown()).optional(),
    requestId: z.string().optional(),
  }),
});
export type ErrorEnvelope = z.infer<typeof errorEnvelopeSchema>;

/** Human-readable text for the dashboard. Keep in sync with errorCodeSchema. */
export const ERROR_MESSAGES: Record<ErrorCode, string> = {
  VALIDATION: 'Some fields are invalid.',
  UNAUTHORIZED: 'Please sign in again.',
  FORBIDDEN: 'You do not have permission to do that.',
  NOT_FOUND: 'Not found.',
  CONFLICT: 'That conflicts with something that already exists.',
  RECIPIENT_NOT_OPTED_IN: 'This number is not opted in.',
  TEMPLATE_NOT_APPROVED: 'This template is not approved by Meta.',
  TEMPLATE_PARAM_MISMATCH: 'The number of parameters does not match the template.',
  UNSUPPORTED_MEDIA_TYPE: 'WhatsApp does not accept this file type.',
  MEDIA_NOT_FOUND: 'The file could not be found in storage.',
  MEDIA_TOO_LARGE: 'The file is larger than WhatsApp allows.',
  RATE_LIMITED: 'Too many requests. Try again shortly.',
  ALLOWLIST_BLOCKED: 'Blocked by the send allow-list (non-production environment).',
  INVALID_STATE: 'That action is not allowed in the current state.',
  INTERNAL: 'Something went wrong on our side.',
};
